export const STORAGE_TOKEN = "token";
export const STORAGE_REFRESH_TOKEN = "refreshToken";
export const PREVIOUS_ROUTE = "previousRoute";
export const LASTSYNCTRANSLATIONS = "lastSyncTranslations";
export const TRANSLATIONS = "translations";
export const API_KEY_NAME = "X-Auth-Token";
export const API_KEY_ID_CULTURE = "X-Id-Culture";
export const AUTHORIZATION_NAME = "Authorization";
export const AUTHORIZATION_COOKIES = "Authorization_Cookies";
export const STORAGE_APP_VERSION = "appVersion";
export const STORAGE_USER_LOCATION = "userLocation";

export const SELECTED_CANCELLED_PARTS_REASSIGN = "selectedCancelledPartsReassign";
export type CancelledPartHeaderInfo = {
	procurementSupplierItemGuid: string;
	claimNumber: string;
	procurementCode: string;
	quoteCode: string;
	insurerName: string;
	vehicleFullName: string;
};
export type SelectedCancelledPartsReassign = {
	procurementSupplierItemGuids: string[];
	quoteGuids: string[];
	guidCompanyBuyer: string;
	partsInfo?: CancelledPartHeaderInfo[];
};
export const SESSION_KEYNAME_ANNOUNCEMENT_CHECK = "HAS_CHECKED_ANNOUNCEMENTS";
